import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { set } from 'lodash/fp';

import { Amount } from '@mews-distributor/common';
import { createReducer } from '@mews/framework/redux';

import { BOOKING_RESTARTED } from '../../../modules/global/actionTypes';
import {
    CREATE_RESERVATION_GROUP_FAILED,
    CREATE_RESERVATION_GROUP_STARTED,
    CREATE_RESERVATION_GROUP_SUCCEEDED,
    FETCH_RESERVATION_GROUP_FAILED,
    FETCH_RESERVATION_GROUP_STARTED,
    FETCH_RESERVATION_GROUP_SUCCEEDED,
} from '../../../modules/reservationGroups/actionTypes';
import { Category } from '../../../modules/resourceCategories/types';
import { CHECKOUT_PREVIOUS_STEP_SET } from './actionTypes';
import { Confirmation, ReservationResponse } from './types';

const INITIAL_STATE = {
    hasCheckoutPreviousStep: false,
    isCreditCardAvailable: false,
    isReservationGroupFetching: false,
    paymentRequestId: null,
    orderedProducts: [],
    reservationGroupId: null,
    reservations: [],
    totalAmount: null,
};

const setIsReservationGroupFetching = set('isReservationGroupFetching');
const setCheckoutPreviousStep = set('hasCheckoutPreviousStep');

const updateReservationGroup = (
    state: Confirmation,
    {
        id,
        totalAmount,
        creditCardAvailable,
        paymentRequestId,
        orderedProducts,
        reservations,
        paymentCardId,
        resourceCategories,
    }: {
        id: string;
        totalAmount: Amount | null;
        creditCardAvailable: boolean;
        paymentRequestId: string;
        orderedProducts: Array<ReservationResponse>;
        reservations: Array<ReservationResponse>;
        paymentCardId: string;
        resourceCategories: Array<Category> | null;
    }
) => ({
    ...state,
    isReservationGroupFetching: false,
    reservationGroupId: id,
    paymentCardId,
    paymentRequestId,
    isCreditCardAvailable: creditCardAvailable,
    totalAmount,
    orderedProducts,
    reservations: pipe(
        reservations,
        array.map(
            ({
                id: reservationId,
                roomCategoryId,
                rateId,
                amount,
                number,
                startUtc,
                endUtc,
                availabilityBlockId,
                ...other
            }) => ({
                id: reservationId,
                availabilityBlockId,
                roomId: roomCategoryId,
                roomName: resourceCategories?.find((category) => category.id === roomCategoryId)?.name,
                rateId,
                amount,
                confirmationNumber: number,
                startUtc,
                endUtc,
                ...other,
            })
        )
    ),
});

export const confirmation = createReducer(INITIAL_STATE, {
    [CREATE_RESERVATION_GROUP_STARTED]: setIsReservationGroupFetching(true),
    [CREATE_RESERVATION_GROUP_FAILED]: setIsReservationGroupFetching(false),
    [CREATE_RESERVATION_GROUP_SUCCEEDED]: updateReservationGroup,
    [FETCH_RESERVATION_GROUP_STARTED]: setIsReservationGroupFetching(true),
    [FETCH_RESERVATION_GROUP_FAILED]: setIsReservationGroupFetching(false),
    [FETCH_RESERVATION_GROUP_SUCCEEDED]: updateReservationGroup,
    [CHECKOUT_PREVIOUS_STEP_SET]: setCheckoutPreviousStep(true),
    [BOOKING_RESTARTED]: () => INITIAL_STATE,
});
